"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressSection = void 0;
var _mui = require("@ori-ui/mui");
var _addressForm = require("@ori/address-form");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _models = require("../../../models");
var _api = require("../../../models/api");
var _utils = require("../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const StyledGridItem = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  order: 10
}));
const StyledTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontWeight: 'bold',
  marginBottom: theme.spacing(5)
}));
const StyledSingleLineLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  width: '100%',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(3)
}));
const StyledSingleLineAddress = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  wordWrap: 'break-word'
}));
const addressKeys = ['addressId', 'addressType', 'country', 'region', 'province', 'district', 'area', 'city', 'locality', 'streetAddress', 'zipcode', 'delivery', 'delivery2', 'delivery3', 'coordinates'];
const pickFields = (obj, fields) => {
  return fields.reduce((acc, key) => {
    // eslint-disable-next-line no-param-reassign -- we need this
    acc[key] = obj[key];
    return acc;
  }, {});
};
const AddressSection = props => {
  const {
    configAddress,
    actualValues
  } = props;
  const {
    setValue
  } = (0, _reactHookForm.useFormContext)();
  const {
    data: formatAddressFields
  } = (0, _api.useAddressFormatMetadata)('SingleLine');
  const [rerenderKey, setRerenderKey] = (0, _react.useState)('');
  const formatedAddress = actualValues?.zipcode ? (0, _utils.getOptionLabelSingleLine)(0, actualValues, formatAddressFields ?? _utils.defaultAddressFormat) : null;
  const isSearchedAddressDisabled = !configAddress?.searchOptions?.isEnabled && !!formatedAddress?.length;
  const singleLineAddress = formatedAddress ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSingleLineLabel, {
      variant: "caption",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.FirstStep_SearchedAddress,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_SearchedAddress
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSingleLineAddress, {
      variant: "body1",
      children: formatedAddress
    })]
  }) : null;
  const setAddressToForm = address => {
    const onlyAddress = pickFields(address, addressKeys);
    Object.entries(onlyAddress).forEach(([name, inputValue]) => {
      const options = inputValue?.toString() ? {
        shouldValidate: true,
        shouldDirty: true
      } : {};
      setValue(`address.${name}`, inputValue, options);
    });
    setRerenderKey('change values');
  };
  const getAddressAutocomplete = () => {
    if (configAddress?.searchOptions?.isEnabled) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
        marginBottom: formatedAddress ? 5 : 6,
        style: {
          order: configAddress.searchOptions.displayOrder
        },
        children: [/*#__PURE__*/(0, _react.createElement)(_addressForm.AddressAutoComplete, {
          ...configAddress,
          name: "autocomplete",
          key: rerenderKey,
          fields: formatedAddress ?? '',
          minSearchLength: 3,
          searchOptions: configAddress.searchOptions,
          maxResults: configAddress.searchOptions.maxResults,
          country: actualValues?.country,
          setAddressToForm: setAddressToForm
        }), isSearchedAddressDisabled ? singleLineAddress : null]
      });
    }
    return null;
  };
  const addressAutocomplete = getAddressAutocomplete();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledGridItem, {
    size: {
      xs: 12
    },
    children: [configAddress?.searchOptions?.isEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      variant: "subtitle1",
      textAlign: "left",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.FirstStep_Address,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.FirstStep_Address
      })
    }) : null, configAddress ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_addressForm.AddressFormFields, {
      config: configAddress,
      initialValues: actualValues,
      customPrefix: "address."
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      size: {
        xs: 12
      },
      style: {
        order: configAddress?.searchOptions?.displayOrder
      },
      children: addressAutocomplete
    })]
  });
};
exports.AddressSection = AddressSection;